import React from 'react';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as HELPERS from '../../helper_functions/helper_functions';

const ControlsPage = ({ controls, handleCurrentControls, handleCurrentPage }) => {

  const [toggleSave, setToggleSave] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    setVehicles([...controls.vehicles]);
    setEmployees([...controls.employees]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleInputs = (e, type) => {
    let newToggleSave = [...toggleSave];
    
    switch ( type ) {
      case 'password':
        e.target.type = e.target.type === 'password' ? 'text' : 'password';
        break;
      case 'change':
        if (/\w/.test(e.target.value)) {
          if (!newToggleSave.includes(e.target.name)) {
            newToggleSave.push(e.target.name)
            setToggleSave(newToggleSave);
          }
          if (e.target.name === 'handleEmployee') {
            [...employees].map((em) => {
              if (em.id === e.target.id) {
                em.name = e.target.value
              }
              return em
            })
          }else if (e.target.name === 'handleVehicle') {
            [...vehicles].map((vc) => {
              if (vc.id === e.target.id) {
                vc.name = e.target.value
              }
              return vc
            })
          }
        }else {
          newToggleSave = [...toggleSave].filter((x) => (x !== e.target.name ))
          setToggleSave(newToggleSave)
        }
        break;
      case 'deleteEmployee':
        let newEmployees = [...employees].map((em) => {
          if (em.id === e) {
            if (em.state === 'delete') {
               delete em.state
            }else {
              em.state =  'delete'   
            }

          }
          return em
        });
        setEmployees(newEmployees)        
        
        if (!newToggleSave.includes('deleteEmployee')) {
          newToggleSave.push('deleteEmployee')
          setToggleSave(newToggleSave);
        }
        break;
      case 'deleteVehicles':
        let newVehicles = [...vehicles].map((ve) => {
          if (ve.id === e) {
            ve.state = ve.state === 'delete' ? '' : 'delete'
          }
          return ve
        });
        setVehicles(newVehicles)        
        
        if (!newToggleSave.includes('deleteVehicles')) {
          newToggleSave.push('deleteVehicles')
          setToggleSave(newToggleSave);
        }
        break;
      case 'addEmployee':
        let newEmployeeValue = document.getElementById('addEmployee');
        
        if (newEmployeeValue.value) {
          let newEmployees = [...employees];
          newEmployees.push({
            "id": HELPERS.randomID(),
            "name": newEmployeeValue.value
          })
          newEmployeeValue.value = '';
          setEmployees(newEmployees);
          if (!newToggleSave.includes('addEmployee')) {
            newToggleSave.push('addEmployee')
            setToggleSave(newToggleSave);
          }
        }
        break;
      case 'addVehicle':
        let newVehicleValue = document.getElementById('addVehicle');
        
        if (newVehicleValue.value) {
          let newVehicles = [...vehicles];
          newVehicles.push({
            "id": HELPERS.randomID(),
            "name": newVehicleValue.value
          })
          newVehicleValue.value = '';
          setVehicles(newVehicles);
          if (!newToggleSave.includes('addVehicle')) {
            newToggleSave.push('addVehicle')
            setToggleSave(newToggleSave);
          }
        }
        break;
      default:
    }
  }

  const handleSave = (e, type) => {
    e.preventDefault();
    let newControls = {...controls};
    let newToggleSave ;
    switch ( type ) {
      case 'counterLength':
      case 'percentage':
      case 'adminPassword':
      case 'assistantPassword':
        let ele = document.getElementById(type);
        newControls[type] = ele.value;
        handleCurrentControls(newControls);
        newToggleSave = [...toggleSave].filter((x) => x !== type)
        setToggleSave(newToggleSave)
        break;
      case 'addEmployee':
        newControls.employees = [...employees].filter((em) => em.state !== 'delete');
      
        setEmployees(newControls.employees);

        handleCurrentControls(newControls, 'updateEmployees');
        newToggleSave = [...toggleSave].filter((x) => (x !== 'addEmployee' && x !== "deleteEmployee" && x !== "handleEmployee" ))
        setToggleSave(newToggleSave)
        break;
      case 'addVehicle':
        newControls.vehicles = [...vehicles].filter((ve) => ve.state !== 'delete');
        setVehicles(newControls.vehicles);
        handleCurrentControls(newControls, 'updateVehicles')
        newToggleSave = [...toggleSave].filter((x) => (x !== 'addVehicle' && x !== "deleteVehicles" && x !== "handleVehicle" ))
        setToggleSave(newToggleSave)
        break;
      default :
    }
  }

  return (
    <section className="controls-page">
      <section className="admin-page-links">
        <Link to='/delivery-assistant/' className="back-arrow" title="orders page">⟰</Link>
        <p>/</p>
        <button onClick={() => handleCurrentPage('adminHomePage')}>Admin_Page</button>
      </section>

      <h1>Controls page</h1>
      <div className="con">
        <p>Control the counter by the minutes</p>
        <form onSubmit={(e) => handleSave(e, 'counterLength')}>
          <input 
            className="nums" 
            type='number' 
            min='1' 
            defaultValue={controls.counterLength}
            id='counterLength'
            name='counterLength'
            onChange={(e) => handleInputs(e, 'change')}
            />
          {toggleSave.includes('counterLength') && <button>Save</button>}
        </form>
      </div>

      <div className="con">
        <p>The percentage to calculate employee funds</p>
        <form onSubmit={(e) => handleSave(e, 'percentage')}>
          <input 
            className="nums" 
            type='number' 
            min='1' 
            id='percentage'
            name='percentage'
            defaultValue={controls.percentage}
            onChange={(e) => handleInputs(e, 'change')}
            />
          {toggleSave.includes('percentage') && <button>Save</button>}
        </form>
      </div>

      <div className="con">
        <p>Manager Password</p>
        <form onSubmit={(e) => handleSave(e, 'adminPassword')}>
          <input 
            onFocus={(e) => handleInputs(e, 'password')}
            onBlur={(e) => handleInputs(e, 'password')}
            onChange={(e) => handleInputs(e, 'change')}
            type='password' 
            min='1' 
            id='adminPassword'
            name='adminPassword'
            defaultValue={controls.adminPassword}
            className="nums"/>
          {toggleSave.includes('adminPassword') && <button>Save</button>}
        </form>
      </div>

      <div className="con">
        <p>Assistant Password</p>
        <form onSubmit={(e) => handleSave(e, 'assistantPassword')}>
          <input 
            onFocus={(e) => handleInputs(e, 'password')}
            onBlur={(e) => handleInputs(e, 'password')}
            onChange={(e) => handleInputs(e, 'change')}
            type='password' 
            min='1' 
            id='assistantPassword'
            name='assistantPassword'
            defaultValue={controls.assistantPassword}
            className="nums"/>
          {toggleSave.includes('assistantPassword') && <button>Save</button>}
        </form>
      </div>

      <div className="con em">
        <form className="ev-con" onSubmit={(e) => handleSave(e, 'addEmployee')}>
          <h3>Employees</h3>
          {
            employees.map((employee) => (
              <div className="data-value tog" key={employee.id}>
                <input 
                  type='text' 
                  defaultValue={employee.name} 
                  name='handleEmployee'
                  id={employee.id}
                  onChange={(e) => handleInputs(e, 'change')}
                  style={{backgroundColor: `${employee.state === 'delete' ? 'lightgray': ''}`}}
                  />
                <div 
                  className="remove-toggle" 
                  onClick={() => handleInputs(employee.id, 'deleteEmployee')}
                >{employee.state === 'delete' ? '✔' : '✘'}</div>
              </div>
            ))
          }
          <div className="data-value add-new" >
            <input 
              type='text'  
              id='addEmployee'
              placeholder="add new employee"
            />
            <div className="remove-toggle" onClick={() => handleInputs('','addEmployee')}>+</div>
          </div>
          {(toggleSave.includes('handleEmployee') || toggleSave.includes('addEmployee') || toggleSave.includes('deleteEmployee')) && <button>Save</button>}
        </form>

        <form className="ev-con toggle-save" onSubmit={(e) => handleSave(e, 'addVehicle')}>
          <h3>Vehicles</h3>
          {
            vehicles.map((vehicle) => (
              <div className="data-value tog" key={vehicle.id}>
                <input 
                  type='text' 
                  name='handleVehicle'
                  id={vehicle.id}
                  defaultValue={vehicle.name} 
                  onChange={(e) => handleInputs(e, 'change')}
                  style={{backgroundColor: `${vehicle.state === 'delete' ? 'lightgray': ''}`}}
                />
                <div 
                  className="remove-toggle" 
                  onClick={() => handleInputs(vehicle.id, 'deleteVehicles')}
                >{vehicle.state === 'delete' ? '✔' : '✘'}</div>
              </div>
            ))
          }
          <div className="data-value add-new" >
            <input 
              type='text'  
              id='addVehicle'
              placeholder="add new vehicle"
              />
            <div className="remove-toggle" onClick={() => handleInputs('','addVehicle')}>+</div>
          </div>
          {(toggleSave.includes('handleVehicle') || toggleSave.includes('addVehicle') || toggleSave.includes('deleteVehicles')) && <button>Save</button>}
        </form>
      </div>
    </section>
  )
}

export default ControlsPage;